var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "page-title" }, [
      _vm._v(" " + _vm._s(_vm.$t("developer.application_setting")) + " "),
    ]),
    _c(
      "div",
      { staticClass: "merchant-application-detail page-container" },
      [
        _c("div", { staticClass: "setting-item" }, [
          _c(
            "p",
            { staticClass: "setting-title" },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("developer.shared_application_setting")) +
                  " "
              ),
              _c(
                "el-tooltip",
                { attrs: { placement: "top" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { slot: "content" },
                      slot: "content",
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("tips.shared_application_setting_tips"))
                        ),
                      ]),
                    ]
                  ),
                  _c("svg-icon", {
                    attrs: {
                      "class-name": "icon-question",
                      "icon-class": "help-question",
                    },
                  }),
                ],
                1
              ),
              _c("el-switch", {
                staticStyle: { "margin-left": "10px" },
                attrs: {
                  "active-value": 1,
                  "inactive-value": 2,
                  "active-text":
                    _vm.sharePublicKeyStatus === 1 ? "Open" : "Close",
                  "active-color": "#67C23A",
                  "inactive-color": "#F56C6C",
                  disabled: !_vm.publicKeyFlag,
                },
                on: { change: _vm.changeSharePublicKeyStatus },
                model: {
                  value: _vm.sharePublicKeyStatus,
                  callback: function ($$v) {
                    _vm.sharePublicKeyStatus = $$v
                  },
                  expression: "sharePublicKeyStatus",
                },
              }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "setting-item" }, [
          _c("p", { staticClass: "setting-title" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("developer.application_information")) + " "
            ),
          ]),
          _c("div", { staticStyle: { "margin-top": "16px" } }, [
            _c("span", { staticClass: "setting-key" }, [_vm._v("AppId:")]),
            _c("span", { staticClass: "setting-value" }, [
              _vm._v(_vm._s(_vm.application.app_id)),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "setting-item" }, [
          _c("p", { staticClass: "setting-title" }, [_vm._v("Webhook")]),
          _c("div", { staticClass: "setting-item-content" }, [
            _c(
              "div",
              { staticClass: "setting-item-content-left" },
              [
                _c("span", { staticClass: "setting-key" }, [
                  _vm._v("Pay out: "),
                ]),
                !_vm.noticeWebhookFlag
                  ? _c("span", { staticClass: "setting-value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.application.notice_webhook
                            ? _vm.application.notice_webhook
                            : ""
                        )
                      ),
                    ])
                  : [
                      _c("el-input", {
                        staticClass: "search-frame",
                        attrs: {
                          placeholder: _vm.$t("merchant.notice_webhook"),
                        },
                        model: {
                          value: _vm.webhookForm.notice_webhook,
                          callback: function ($$v) {
                            _vm.$set(_vm.webhookForm, "notice_webhook", $$v)
                          },
                          expression: "webhookForm.notice_webhook",
                        },
                      }),
                    ],
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "setting-item-content-right" },
              [
                !_vm.noticeWebhookFlag
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.changeWebhookInput(1)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("components.edit")) + " ")]
                    )
                  : _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.submitMchWebhook(1)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("components.submit")))]
                    ),
              ],
              1
            ),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "setting-item" },
          [
            _c(
              "p",
              { staticClass: "setting-title" },
              [
                _vm._v(" API Key "),
                _c("el-tooltip", { attrs: { placement: "top" } }, [
                  _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                    _c("span", [
                      _vm._v(" " + _vm._s(_vm.$t("tips.public_key_introduce"))),
                    ]),
                    _vm._v(" "),
                    _c("br"),
                  ]),
                  _c(
                    "span",
                    [
                      _c("svg-icon", {
                        attrs: {
                          "class-name": "icon-question",
                          "icon-class": "help-question",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
            _c("div", { staticClass: "setting-item-content" }, [
              _c("div", { staticClass: "setting-item-content-left" }, [
                _c("span", { staticClass: "setting-key" }, [
                  _vm._v(" " + _vm._s(_vm.$t("developer.public_key")) + ": "),
                ]),
                !_vm.publicKeyInputFlag
                  ? _c(
                      "span",
                      {
                        staticClass: "setting-value",
                        staticStyle: { position: "relative", top: "3px" },
                      },
                      [_vm._v(_vm._s(_vm.hiddenInfo.public_key))]
                    )
                  : _vm._e(),
              ]),
              _c(
                "div",
                { staticClass: "setting-item-content-right" },
                [
                  _vm.publicKeyFlag && !_vm.publicKeyInputFlag
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.changeHiddenInput(1)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("components.edit")))]
                      )
                    : _vm._e(),
                  _vm.publicKeyInputFlag
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitReSetPublicSecret(1)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("components.submit")))]
                      )
                    : _vm._e(),
                  [
                    !_vm.publicKeyFlag
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary", plain: "" },
                            on: {
                              click: function ($event) {
                                return _vm.showUserAuthenticationModal(
                                  "public_key_second"
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("components.view")) + " "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                ],
                2
              ),
            ]),
            _vm.publicKeyInputFlag
              ? _c("el-input", {
                  staticStyle: { "margin-top": "12px" },
                  attrs: { type: "textarea", rows: 8, clearable: "" },
                  model: {
                    value: _vm.hiddenForm.public_key,
                    callback: function ($$v) {
                      _vm.$set(_vm.hiddenForm, "public_key", $$v)
                    },
                    expression: "hiddenForm.public_key",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _c("div", { staticClass: "setting-item" }, [
          _c(
            "p",
            { staticClass: "setting-title" },
            [
              _vm._v(_vm._s(_vm.$t("developer.ip_white_list")) + " "),
              _c("el-tooltip", { attrs: { placement: "top" } }, [
                _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                  _c("span", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$store.getters.isAruxpay
                            ? _vm.$t("tips.ip_white_aruxpay_introduce")
                            : _vm.$t("tips.ip_white_ezpay_introduce")
                        )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                ]),
                _c(
                  "span",
                  [
                    _c("svg-icon", {
                      attrs: {
                        "class-name": "icon-question",
                        "icon-class": "help-question",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "setting-item-content" }, [
            _c(
              "div",
              { staticClass: "setting-item-content-left" },
              [
                _c("span", { staticClass: "setting-key" }, [
                  _vm._v(_vm._s(_vm.$t("developer.ip_address")) + ": "),
                ]),
                !_vm.ipKeyInputFlag
                  ? _c(
                      "span",
                      {
                        staticClass: "setting-value",
                        staticStyle: { position: "relative", top: "3px" },
                      },
                      [_vm._v(_vm._s(_vm.hiddenInfo.white_ips))]
                    )
                  : _vm._e(),
                void 0,
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "setting-item-content-right" },
              [
                [
                  !_vm.ipKeyFlag
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.showUserAuthenticationModal(
                                "white_ips_second"
                              )
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("components.view")) + " ")]
                      )
                    : _vm._e(),
                ],
              ],
              2
            ),
          ]),
        ]),
        _c(
          "el-dialog",
          {
            attrs: {
              title: _vm.$t("developer.shared_application_setting"),
              visible: _vm.dialogVisible,
              width: "30%",
              "before-close": _vm.closeSharePublicKeyDialog,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible = $event
              },
            },
          },
          [
            _c("p", { staticStyle: { "margin-bottom": "50px" } }, [
              _vm._v(_vm._s(_vm.$t("tips.share_public_key_introduce"))),
            ]),
            _c(
              "div",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  { on: { click: _vm.closeSharePublicKeyDialog } },
                  [_vm._v(_vm._s(_vm.$t("components.cancel")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.submitSharePublicKey()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("components.confirm")))]
                ),
              ],
              1
            ),
          ]
        ),
        _c("AppIdentityEmailCheckModal", {
          ref: "identityCheckPublicKeyRef",
          attrs: { app_id_second: _vm.checkType },
          on: { showHiddenInfo: _vm.showHiddenInfo },
        }),
        _c("AppIdentityEmailCheckModal", {
          ref: "identityCheckWhiteIpsRef",
          attrs: { app_id_second: _vm.checkType },
          on: { showHiddenInfo: _vm.showHiddenInfo },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }